import { TextareaContentMeasurementElement as n } from "./textarea-content-measurement-element.js";
class i {
  /*
   * Instance of the TextareaContentMeasurementElement
   */
  textareaMeasurementElement;
  /*
   * textarea html element to set the height for.
   */
  textarea;
  /*
   * the textInput element that contains the textarea.
   */
  textInputElement;
  constructor(e, t, a) {
    this.textareaMeasurementElement = a ?? new n(), this.textarea = e, this.textInputElement = t ?? void 0;
  }
  /**
   * Gets the text to be measured.
   *
   * @returns The relevant text to be measured.
   */
  getTextToMeasure() {
    return this.textarea.value || this.textarea.placeholder || "&nbsp;";
  }
  /**
   * Gets the parent of the textInput Element and calls addMarginToElement. This helps with proper sizing of placeholder text when creating the measuring div.
   *
   * @param textInputElement the text input element.
   */
  getTextInputParentElement(e) {
    const t = e.parentElement;
    t && this.textareaMeasurementElement.addMarginToElement(t);
  }
  /**
   * Resize the text area to fix the contents.
   */
  fitHeightToText() {
    this.textInputElement && this.getTextInputParentElement(this.textInputElement);
    const e = this.textareaMeasurementElement.getTextHeight(
      this.getTextToMeasure()
    );
    this.setTextareaHeight(e);
  }
  /**
   * Sets the height of the text area.
   *
   * @param height the height to set the textarea to
   */
  async setTextareaHeight(e) {
    this.textarea.style.height = e + 1 + "px";
  }
}
export {
  i as TextareaHeightMeasurementManager
};
//# sourceMappingURL=textarea-height-measurement-manager.js.map
